export default __webpack_public_path__ + "static/media/(14).b4964a2a.jpeg";